import {useSelector} from "react-redux";
import {financeSelector} from "../../../../redux/slices/financeSlice";
import {globalDataSelector} from "../../../../redux/slices/globalDataSlice";
import {useTranslation} from "react-i18next";
import React, {useEffect} from "react";
import s from "./activateSubscriptionTopUpBalancePopup.module.scss";
import SvgSelector from "../../../SvgSelector/SvgSelector";
import BaseTextInput from "../../../BaseTextInput/BaseTextInput";
import {snackbar_info} from "../../../../utils/vars/staticVariables";
import {getLanguage} from "../../../../storage/switchLanguage";

const ActivateSubscriptionTopUpBalancePopup = ({
                                                   setActive,
                                                   active,
                                                   action,
                                                   isRenewSubscription,
                                                   subscriptionName,
                                                   subscriptionPrice
                                               }) => {
    const { wallet, balance, topUpBalanceIsActive } = useSelector(financeSelector);
    const { exitPopup, isCollapsedSidebar } = useSelector(globalDataSelector);

    const { t } = useTranslation();

    const handleClosePopup = (event) => {
        if (event.target.classList.contains(s.popupWrapper)) {
            setActive(false);
        }
    };

    useEffect(() => {
        if (topUpBalanceIsActive || exitPopup) {
            setActive(false);
        }
    }, [topUpBalanceIsActive, exitPopup]);

    const handleWrapperClick = (event) => {
        if (event.target.classList.contains(s.popupWrapper)) {
            handleClosePopup(event);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setActive(false);
        action();
    };

    useEffect(() => {
        const handleEscClose = (e) => {
            if (e.key === "Escape") {
                setActive(false);
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            }
        };
        const handleEnterPress = (e) => {
            if (e.key === "Enter") {
                if (document.activeElement) {
                    document.activeElement.blur();
                }
                handleSubmit(e);
            }
        };
        if (active) {
            document.addEventListener("keydown", handleEscClose);
            document.addEventListener("keydown", handleEnterPress);
        }

        return () => {
            document.removeEventListener("keydown", handleEscClose);
            document.removeEventListener("keydown", handleEnterPress);
        };
    }, [active]);

    const depositAmount = (balance - subscriptionPrice)?.toString()?.replace("-", '')

    return (
        <div
            className={`${s.popupWrapper} ${active ? s.active : ""} ${isCollapsedSidebar === "true" ? s.collapsed : ""}`}
            onClick={handleWrapperClick}
        >
            <div
                className={active ? `${s.popup} ${s.active}` : s.popup}
            >
                <div className={s.header}>
                    <button
                        onClick={() => setActive(false)}
                        className={s.closePopup}
                        type="button"
                    >
                        <SvgSelector id="close-popup" />
                    </button>
                    <div className={s.icon}>
                        <SvgSelector id="subscriptions-icon" />
                    </div>
                    <div className={s.popupInfo}>
                        <p className={s.title}>{t(isRenewSubscription ? 'tariff_renewal' : 'tariff_activation')}</p>
                    </div>
                </div>
                <div className={s.body}>
                    <div className={s.descriptions}>
                        <p className={s.mainDescription}>
                            {
                                `${t('you_are_about_to')}
                                 ${isRenewSubscription 
                                    ? t('renew') 
                                    : t('activate')}`}
                            {" "}
                            <span className={s.distinguished}>
                                {subscriptionName}
                            </span>
                            {" " + t('subscription_word_in_popup_description')}

                            {/*{t("you_are_about_to_activate")}{" "}*/}
                            {/*<span className={s.distinguished}>Тестовый тариф</span>{" "}*/}
                            {/*для новых пользователей.*/}
                            {/*{*/}
                            {/*    getLanguage() === 'en' ? ` $50 ${t('will_be_deducted_from_your_balance')}` :*/}
                            {/*        `${t('will_be_deducted_from_your_balance')}50`*/}
                            {/*}*/}
                        </p>
                        <p className={s.subdescription}>
                            {t('tariff_unsufficient_funds')}
                            {t('top_up_your_balance_with')}
                            ${depositAmount}
                            .{" "}
                            {t('subscriptions_after_successful_top_up')}
                            <span className={s.distinguished}>"{t(isRenewSubscription ? "renew_button" : 'activate_button')}"</span>
                            {t('on_the_selected_tariff_plan')}
                        </p>
                    </div>
                    <div className={s.copyInputContainer}>
                        <p className={s.inputDesc}>{t("crypto_wallet")}(USDT TRC20)</p>
                        <BaseTextInput
                            value={wallet}
                            placeholder={t("loading")}
                            copy={true}
                            alertMessage={t("notif_crypto_wallet_copied")}
                            alertType={snackbar_info}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActivateSubscriptionTopUpBalancePopup;